"use client";

import { useMemo } from "react";
import { useToasts } from "@/components/ui/toast-provider";

type Variant = "info" | "success" | "error" | "warning";

export interface ShowToastOptions {
  title: string;
  description?: string;
  variant?: Variant;
}

function variantToPhase(v: Variant) {
  switch (v) {
    case "success":
      return "success" as const;
    case "error":
      return "error" as const;
    case "warning":
      return "pending" as const;
    default:
      return "confirm" as const;
  }
}

export function useToast() {
  const { upsert, dismiss } = useToasts();

  const api = useMemo(
    () => ({
      showToast: ({ title, description, variant = "info" }: ShowToastOptions) => {
        const id = `toast-${Math.random().toString(36).slice(2)}`;
        upsert({
          id,
          phase: variantToPhase(variant),
          title,
          subtitle: description,
          open: true,
        });
        return id;
      },
      dismissToast: (id: string) => dismiss(id),
    }),
    [upsert, dismiss],
  );

  return api;
}
